var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4168 7.98428L12.5283 4.18195C11.6457 3.49534 10.4097 3.49534 9.52709 4.18195L4.63759 7.98428C4.04212 8.44735 3.69398 9.15954 3.69434 9.91386V16.5139C3.69434 17.5264 4.51515 18.3472 5.52767 18.3472H16.5277C17.5402 18.3472 18.361 17.5264 18.361 16.5139V9.91386C18.361 9.15945 18.0127 8.4472 17.4168 7.98428",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4168 7.98428L12.5283 4.18195C11.6457 3.49534 10.4097 3.49534 9.52709 4.18195L4.63759 7.98428C4.04212 8.44735 3.69398 9.15954 3.69434 9.91386V16.5139C3.69434 17.5264 4.51515 18.3472 5.52767 18.3472H16.5277C17.5402 18.3472 18.361 17.5264 18.361 16.5139V9.91386C18.361 9.15945 18.0127 8.4472 17.4168 7.98428",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 13.7499C12.6405 14.9718 9.35701 14.9718 7.33301 13.7499",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 13.7499C12.6405 14.9718 9.35701 14.9718 7.33301 13.7499",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/dashIcon.f145a1b1114f2310337aba61a40db3d7.svg";
export { ForwardRef as ReactComponent };